export default "__VITE_ASSET__DYsTGcXl__"